<template>
  <div class="products-result-base" :style="styles">
    <h1><img class="head-img" src="/static/img/recommend/lp/kurenotori/products/head_fortune0002.png" alt=""></h1>
    <div class="result-base" v-if="this.resultList.length > 0">
      <h2>あの人の気持ちと二人の未来</h2>
      <img src="/static/img/recommend/lp/kurenotori/products/baika-image.png" alt="" class="main-image">
      <div
        class="block-result-item"
        v-for="(item, idx) in resultList"
        :key="`res${idx}`"
      >
        <div class="head-str">{{item.blockHead}}</div>
        <div class="description" v-html="item.description"></div>
      </div>
    </div>
    <!-- <menu-block /> -->
    <!-- <banner-block /> -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />
  </div>
</template>
<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import moment from "moment";
import * as type from '@/utvStore/store/mutation-types'

import BannerBlock from '../partials/BannerBlock'
import MenuBlock from '../partials/MenuBlock'
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'

export default {
  name: 'ProductsKurenotoriIndex',
  components: {
    BannerBlock,
    MenuBlock,
    RecommendBlockPlus,
  },
  props: {
    resultData: {
      type: Object,
      default: null,
    },
    requireProf: {
      type: Array,
      default: null,
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      regBirthValid: false,
      regBirthErr: '',
      regBirthInit: false,
      regBirthVal: null,
    }
  },
  computed: {
    resultList(){
      const HEAD_WORDS = {
        text1: {
          head: 'その言葉に込められた真意',
        },
        text2: {
          head: 'あの人は、あなたに何を望んでいる？',
        },
        text3: {
          head: 'これから二人はどうなっていく？',
        },
        text4: {
          head: '暮れの酉からのメッセージ',
        },
      }

      return !!this.resultData && this.resultData.kurenotori_0003_01
        ? Object.keys(this.resultData.kurenotori_0003_01).map( key => {
          return {
            blockHead: HEAD_WORDS[key].head,
            description: this.resultData.kurenotori_0003_01[key]
          }
        }) : null
    },
    formatedBirthdate(){
      return !!this.regBirthVal ? this.regBirthVal.format('YYYY-MM-DD') : ''
    },
    counselorInfos(){
      return BASIC_DATA.kurenotori
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
    console.log('hououType: %O', this.hououType)
    console.log('resultList: %O', this.resultList)
    console.log('resultListMod: %O', this.resultListMod)
  },
  methods: {
    onBirthdayChange(val){
      if(!this.regBirthInit){
        this.regBirthInit = true
      }else {
        if (val.length === 8) {
          const y = val.substring(0, 4)
          const m = val.substring(4, 6)
          const d = val.substring(6, 8)

          const now = new moment()
          const mom = new moment([+y,+m-1,+d])

          if (mom.isBetween('1940-01-01', now, null, '[)') && mom.isValid()){
            this.regBirthErr = ''
            this.regBirthVal = mom
            this.regBirthValid = true
          }else{
            this.regBirthErr = '正しい日付を入力してください'
            this.regBirthValid = false
            this.regBirthVal = null
          }
        } else {
          this.regBirthErr = ''
          this.regBirthValid = false
          this.regBirthVal = null

        }
      }
    },
    onRegBirthSubmitClick(){
      this.$refs.regbirth.submit()
    }
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables.scss";

$tori_navy:#142254;
$uranaitv_black:#32373f;

/deep/ {
  img {
    max-width: 100%;
    display: block;
  }
  p {
    margin: 0 auto 24px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

.products-result-base {
  background: url(/static/img/recommend/lp/kurenotori/bg_baikashineki3.png) repeat-y;
  background-size: 100% auto;
  padding-top: 40px;
  h1 {
    margin: 0 auto 24px;
  }
  .result-base {
    background: white;
    width: calc(100% - 36px);
    margin: 0 auto 24px;
    padding: 15px;
    padding-bottom: 24px;
    border: 1px solid $tori_navy;
    border-radius: 10px;
    margin-bottom: 24px;
    h1 {
      margin: 0;
      padding-top: 40px;
    }
    h2{
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color: $tori_navy;
      margin: 16px 0 24px;
      .pre-word {
        display: block;
        font-size: 0.8em;
      }
    }
    h4{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 16px;
      color: $tori_navy;
      margin: 0;
      margin-bottom: 8px;
    }
  }
}



.head-str {
  background-color: white;
  position: absolute;
  top: 0;
  left: 15px;
  padding-bottom: 22px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color:$tori_navy;
}
.year-icon{
  position: absolute;
  z-index: 2;
  top: -2px;
  left: 2px;
}


.block-result-item{
  padding-top: 45px;
  position: relative;
  padding-bottom:24px;

  img{
    margin-bottom: 8px;
  }

}
.main-image{
  margin-bottom: 24px;
}
.description{
  background-color: #ffffff;
  color: $uranaitv_black;
  padding-top: 0;
  position: relative;
  @include mq('w580') {
  }
}

.head-img {
  width: 144px;
  margin: auto;
}

.regist-birthdate {
  padding: 24px 24px 32px;
  background: var(--mess-bg);
  border-radius: 10px;
  width: 88vw;
  margin: auto;
  margin-bottom: 30px;
  text-align: center;
  color: var(--key-color);
  font-size: 16px;
  @include mq('w580') {
    width: 80%;
  }
  .br-pc {
    display: none;
    @include mq('w580'){
      display: inline;
    }
  }

  .error-title {
    font-weight: bold;
    margin-bottom: 16px;
  }
  .links {
    font-weight: bold;
    margin-bottom: 16px;
  }
  ul {
    margin-bottom: 12px;
    li {
      color: red;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      margin: 0 auto;
      padding-left: 20vw;
      @include mq('w580') {
        width: 50%;
        padding: 0;
      }
    }
  }
  a {
    color: #547fe4;
    text-decoration: none;
    border-bottom: 1px solid red;
    padding-bottom: 3px;
    font-weight: bold;
  }

}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/fortunes/ProductsResult03.vue